import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kys-header',
  templateUrl: './kys-header.component.html',
  styleUrls: ['./kys-header.component.scss']
})
export class KysHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
